import { render, staticRenderFns } from "./Step1.vue?vue&type=template&id=51b12fcc&scoped=true"
import script from "./Step1.vue?vue&type=script&lang=js"
export * from "./Step1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b12fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b12fcc')) {
      api.createRecord('51b12fcc', component.options)
    } else {
      api.reload('51b12fcc', component.options)
    }
    module.hot.accept("./Step1.vue?vue&type=template&id=51b12fcc&scoped=true", function () {
      api.rerender('51b12fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/Step1.vue"
export default component.exports